var map = {
	"./background.jpg": "1100",
	"./brand.jpg": "f893",
	"./brand.svg": "2b3a",
	"./colors.scss": "62d7",
	"./custom.scss": "de82",
	"./fonts.scss": "7929",
	"./fonts/texgyrepagella-bold.otf": "791d",
	"./fonts/texgyrepagella-bolditalic.otf": "49b7",
	"./fonts/texgyrepagella-italic.otf": "ec82",
	"./fonts/texgyrepagella-regular.otf": "75fe",
	"./logo-footer-1.svg": "d097",
	"./logo-footer-2.png": "f0b2",
	"./logo-footer-3.jpg": "1efb",
	"./logo-footer.jpg": "364b",
	"./variables.scss": "7133"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";